var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M10 19v-7H3v-2h7V3h2v7h7v2h-7v7z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }